let CURRENT_REQUEST_NUMBER = 0;

export const incrementLabelsDataRequestNumber = () => {
  CURRENT_REQUEST_NUMBER = CURRENT_REQUEST_NUMBER + 1;
};

export const getCurrentLabelsDataRequestNumber = () => CURRENT_REQUEST_NUMBER;
